import CustomLottingList from '../../components/CustomLottingList';

const LottingList = () => {
  return <CustomLottingList normative="coe" />;
};

export default LottingList;
